<template>
    <CompassEmptyState
        illustrationPath="/ressources/logged/img/illustrations/empty-report-favorites.svg"
        :title="translations.title"
        :caption="translations.caption"
    >
        <CompassButton
            :label="translations.actions.redirect_to_all_reports"
            @click="$emit('redirectToAllReports')"
        />
    </CompassEmptyState>
</template>

<script>
export default {
    data() {
        return {
            translations: {
                title: this.$t.__('reports.listing.empty_state_favorite.title'),
                caption: this.$t.__('reports.listing.empty_state_favorite.caption'),
                actions: {
                    redirect_to_all_reports: this.$t.__(
                        'reports.listing.empty_state_favorite.actions.redirect_to_all_reports',
                    ),
                },
            },
        };
    },
};
</script>
